<template lang="html">
    <form class="form3" id="onboarding">
        <img id="logo" src="@/assets/logo.svg" alt="" />
        <div v-if="step == 1">
            <span class="info"
                >Welcome to Lesson Pro! <br /><br />So that you can easily add lesson credits to
                your account going forward, we need to take your payment details. Please enter the
                address that your card is registered to below.</span
            >

            <div class="formGroup">
                <label>Your address Line 1</label>
                <input type="text" v-model="form.address_line1" />
                <has-error :form="form" field="address_line1" />
            </div>

            <div class="formGroup">
                <label>Your address Line 2</label>
                <input type="text" v-model="form.address_line2" />
                <has-error :form="form" field="address_line2" />
            </div>

            <div class="formGroup">
                <label>Your city</label>
                <input type="text" v-model="form.address_city" />
                <has-error :form="form" field="address_city" />
            </div>

            <div class="formGroup">
                <label>Post code</label>
                <input type="text" v-model="form.address_postcode" />
                <has-error :form="form" field="address_postcode" />
            </div>

            <div class="formGroup">
                <label>County</label>
                <select v-model="form.address_county">
                    <option></option>
                    <option>Bedfordshire</option>
                    <option>Berkshire</option>
                    <option>Bristol</option>
                    <option>Buckinghamshire</option>
                    <option>Cambridgeshire</option>
                    <option>Cheshire</option>
                    <option>City of London</option>
                    <option>Cornwall</option>
                    <option>Cumbria</option>
                    <option>Derbyshire</option>
                    <option>Devon</option>
                    <option>Dorset</option>
                    <option>Durham</option>
                    <option>East Riding of Yorkshire</option>
                    <option>East Sussex</option>
                    <option>Essex</option>
                    <option>Gloucestershire</option>
                    <option>Greater London</option>
                    <option>Greater Manchester</option>
                    <option>Hampshire</option>
                    <option>Herefordshire</option>
                    <option>Hertfordshire</option>
                    <option>Isle of Wight</option>
                    <option>Kent</option>
                    <option>Lancashire</option>
                    <option>Leicestershire</option>
                    <option>Lincolnshire</option>
                    <option>Merseyside</option>
                    <option>Norfolk</option>
                    <option>North Yorkshire</option>
                    <option>Northamptonshire</option>
                    <option>Northumberland</option>
                    <option>Nottinghamshire</option>
                    <option>Oxfordshire</option>
                    <option>Rutland</option>
                    <option>Shropshire</option>
                    <option>Somerset</option>
                    <option>South Yorkshire</option>
                    <option>Staffordshire</option>
                    <option>Suffolk</option>
                    <option>Surrey</option>
                    <option>Tyne and Wear</option>
                    <option>Warwickshire</option>
                    <option>West Midlands</option>
                    <option>West Sussex</option>
                    <option>West Yorkshire</option>
                    <option>Wiltshire</option>
                    <option>Worcestershire</option>
                </select>
                <has-error :form="form" field="address_county" />
            </div>

            <div class="formGroup">
                <label>
                    <input type="checkbox" v-model="form.tos" /> I accept Lesson Pro Terms of
                    service
                </label>
                <has-error :form="form" field="tos" />
            </div>

            <div class="formGroup">
                <button
                    :disabled="form.busy"
                    @click.prevent="createStripeAccount"
                    class="button dark"
                    type="button"
                    name="button"
                >
                    {{ form.busy ? "Please wait" : "Add Address" }}
                </button>
            </div>
        </div>

        <div v-show="step == 2">
            <span class="info"
                >So that you can add lesson credits to your account, please enter your card details.
                We wont take any payments until you buy some credits</span
            >

            <div class="formGroup">
                <label>Name on card</label>
                <input type="text" v-model="form2.name" />
            </div>

            <div class="formGroup" v-show="form2.name.length > 0">
                <div class="card" ref="card"></div>
            </div>

            <div class="formGroup" v-show="form2.name.length > 0">
                <button
                    :disabled="busy"
                    @click.prevent="addCardDetails"
                    class="button dark"
                    type="button"
                    name="button"
                >
                    {{ busy ? "Please wait..." : "Add payment details" }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import { Form, HasError } from "vform";
export default {
    name: "onboarding",
    components: { HasError },
    watch: {
        user() {
            this.checkStep();
        },
    },
    mounted() {
        this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
        var elements = this.stripe.elements();
        this.card = elements.create("card");
        this.card.mount(this.$refs.card);
    },
    created() {
        this.checkStep();
    },
    data() {
        return {
            stripe: "",
            card: "",
            step: 1,
            busy: false,
            form: new Form({
                address_line1: "",
                address_line2: "",
                address_city: "",
                address_postcode: "",
                address_county: "",
                account_name: "",
                sortcode: "",
                accountno: "",
                tos: false,
            }),
            form2: new Form({
                client_secret: "",
                name: "",
                payment_method: "",
            }),
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        checkStep() {
            if (this.user.stripe_id) {
                this.step = 2;
                this.getIntent();
            }
        },
        getIntent() {
            this.form.get("/stripe/intent").then((response) => {
                this.form2.client_secret = response.data.client_secret;
            });
        },
        createStripeAccount: function () {
            this.form.post("/stripe/add-customer").then((response) => {
                this.step = 2;
                this.form2.client_secret = response.data.client_secret;
            });
        },
        addCardDetails() {
            this.busy = true;

            this.stripe
                .confirmCardSetup(this.form2.client_secret, {
                    payment_method: {
                        card: this.card,
                        billing_details: {
                            name: this.form2.name,
                        },
                    },
                })
                .then((result) => {
                    this.busy = false;
                    if (result.error) {
                        this.$notify({
                            type: "error",
                            text: result.error.message,
                        });
                    } else {
                        this.completeSetup(result.setupIntent.payment_method);
                    }
                });
        },
        completeSetup($method) {
            this.form2.payment_method = $method;
            this.$notify("You're all setup. Welcome to Lesson Pro!");
            this.form2.post("/stripe/add-card-details").then((response) => {
                this.$store.state.user.stripe_card = response.data.stripe_card;
            });
            this.$router.push("/");
        },
    },
};
/*
this.$notify({
  type: 'error',
  text: result.error.message
})
*/
</script>

<style lang="scss" scoped>
#onboarding {
    padding: 20px;
    background: $green_1;
    min-height: 100vh;

    #logo {
        width: 240px;
        margin: 20px auto;
        display: block;
    }
    .card {
        width: 100%;
        background: #e7efeb;
        border: 0px;
        padding: 20px;
        border-radius: 12px;
        font-size: 1rem;
        font-family: canada-type-gibson, sans-serif;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        color: #267962;
        max-width: 100%;
        min-width: 100%;
    }
}
</style>
